export const reasonsData = [
  {
    id: '1',
    icon: 'how_to_reg',
    title: 'Liaise with a single point of contact',
    descr: 'Your assigned Account Manager will assist you every step of the way, right from negotiations, until installation and even after-sales service.'
  },
  {
    id: '2',
    icon: 'add_ic_call',
    title: 'Manage after-sales service',
    descr: 'Should you require any after-sales service or maintenance, we are just a call away!'
  },
  {
    id: '3',
    icon: 'local_offer',
    title: 'Enjoy discounts through our Group Deals',
    descr: 'We combine similar requirements from multiple sources, to offer equipment at great price benefits to our customers!'
  }
]

export const aboutUsData = [
  {
    id: '1',
    title: 'About us',
    descr: 'ZEPNURhealth is a tech platform that assists small to mid-sized medical and dental facilities efficiently procure and manage their equipment and consumables. By streamlining offline and online efforts, employing a team of trained biomedical engineers, and maintaining strong relationships with industry leaders, ZEPNURhealth is able to offer a comprehensive tech solution that can help medical facilities curb their expenses and manage their equipment and purchases.'
  },
  {
    id: '2',
    title: 'Why Zepnur?',
    descr: 'Certified Doctors, providing key insights into market trends and consumer preferences.\n\nA strong global network that spans across Australia, Middle East and India.\n\nProfessionals with over 15 years of industry experience, in providing cost-effective and innovative solutions, to keep up with the changing market'
  }
]

export const teamData = [
  {
    id: '1',
    img: require('../assets/images/team-1.png'),
    name: 'Dr Nidun J Kurakar (CEO)',
    descr: 'Dr Nidun has had experience in various fields of healthcare – clinical medicine, clinical research, medical insurance, healthcare policy and occupational health, across 3 continents. His research-oriented approach to understand local challenges and seek global solutions, is key to the direction of ZEPNURhealth.'
  },
  {
    id: '2',
    img: require('../assets/images/team-2.png'),
    name: 'Parvathi Radhakrishnan (COO)',
    descr: 'Parvathi has experience in marketing, advertising, market research and communications. Her customer-centric and data-oriented approach has helped carve out a customized strategy and process for ZEPNURhealth'
  },
  {
    id: '3',
    img: require('../assets/images/team-3.jpg'),
    name: 'Gopinath S (Biomedical Sales - Medical)',
    descr: 'With biomedical sales and service experience across medical, gynecology and other specialties, Gopinath brings with him a no-nonsense approach that builds trust with customers. His expert technical knowledge on brands and products gives him the ability to help the customer make the right purchase decision for their medical facility.'
  },
  {
    id: '4',
    img: require('../assets/images/team-4.jpg'),
    name: 'Hilbert Joe (Biomedical Sales - Dental)',
    descr: 'Hilbert’s out-of-the-box thinking, patience and can-do attitude has helped cultivate strong relationships with his customers. Always looking for an opportunity to upskill, Hilbert’s in-depth knowledge of the Dental space has helped ZEPNURhealth gain a footing in this competitive space.'
  },
  {
    id: '5',
    img: require('../assets/images/team-5.png'),
    name: 'Aakanksha Sinha (Marketing & Communications)',
    descr: 'Aakanksha is an integral part of ZEPNURhealth, supporting the sales and product teams with their respective tasks. Her result-oriented approach has helped us curate customized marketing and sales tactics, while creating a strong online and offline presence for ZEPNURhealth and affiliated products.'
  },
  {
    id: '6',
    img: require('../assets/images/team-6.png'),
    name: 'Sushmitha Naidu (Product & Vendor)',
    descr: 'Sushmitha identifies and onboards key manufacturers and suppliers to our vendor network. She arranges product demos, assists the sales team and compiles technical specs of vendor products for the tech solution, so that customers can do a technical comparison of different products and make an informed purchase decision for their healthcare facility.'
  },
  {
    id: '7',
    img: require('../assets/images/team-7.png'),
    name: 'Gowtham Kumar (Finance)',
    descr: 'Gowtham is responsible for drawing out the financial reports for ZEPNURhealth, that is vital for the Management to take key strategic decisions. He also maintains the payables and receivables for ZEPNURhealth to ensure a strong cash flow for the company.'
  },
]



// WEBPACK FOOTER //
// ./src/Data/AppData.js